/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddDomain200Response
 */
export interface AddDomain200Response {
    /**
     * 
     * @type {string}
     * @memberof AddDomain200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the AddDomain200Response interface.
 */
export function instanceOfAddDomain200Response(value: object): value is AddDomain200Response {
    return true;
}

export function AddDomain200ResponseFromJSON(json: any): AddDomain200Response {
    return AddDomain200ResponseFromJSONTyped(json, false);
}

export function AddDomain200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddDomain200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

  export function AddDomain200ResponseToJSON(json: any): AddDomain200Response {
      return AddDomain200ResponseToJSONTyped(json, false);
  }

  export function AddDomain200ResponseToJSONTyped(value?: AddDomain200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

